import { THIRD_PARTY_REGISTRATION } from './constants';

export const addNewBillingAgreementInitialValues = ({
  sellerName,
  sellerVatNumber,
  sellerPhoneNumber,
  sellerEmail,
  buyerPhoneNumber,
  buyerName,
  buyerVatNumber,
  buyerEmail,
  thirdPartyRegistered,
  thirdPartyPhoneNumber,
  thirdPartyName,
  thirdPartyTinNumber,
  thirdPartyVatNumber,
  thirdPartyEmail,
  agreementStartDate,
  agreementEndDate,
  agreementDocument,
  poaDocument,
  note,
}) => ({
  isTable: false,
  sellerName: sellerName ?? '',
  sellerPhoneNumber: sellerPhoneNumber ?? '',
  sellerVatNumber: sellerVatNumber ?? '',
  sellerEmail: sellerEmail ?? '',
  buyerName: buyerName ?? '',
  buyerPhoneNumber: buyerPhoneNumber ?? '',
  buyerVatNumber: buyerVatNumber ?? '',
  buyerEmail: buyerEmail ?? '',
  thirdPartyRegistered:
    thirdPartyRegistered ?? THIRD_PARTY_REGISTRATION.VAT_REGISTERED,
  thirdPartyName: thirdPartyName ?? '',
  thirdPartyPhoneNumber: thirdPartyPhoneNumber ?? '',
  thirdPartyTinNumber: thirdPartyTinNumber ?? '',
  thirdPartyVatNumber: thirdPartyVatNumber ?? '',
  thirdPartyEmail: thirdPartyEmail ?? '',
  agreementStartDate: agreementStartDate ?? null,
  agreementEndDate: agreementEndDate ?? null,
  agreementDocument: agreementDocument ?? [],
  poaDocument: poaDocument ?? [],
  note: note ?? '',
  termsAndConditions: false,
});
